import {IntegrationHistory, ObjectIntegrationStatus} from "../../../model/integration-history";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export const objectIntegrationStatusSelector = () => createSelector(
  [getUseQueryResultData<ObjectIntegrationStatus>],
  (data) => {
    return data
  }
);

export const integrationHistoriesSelector = () => createSelector(
  [getUseQueryResultData<IntegrationHistory[]>],
  (data) => {
    return data ?? []
  }
);
